import { TUser } from "../features/user/user.types";
import {
  TPricingPlan,
  TPricingPlanDto,
} from "../features/pricingPlans/pricingPlans.types";

export const wait = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getRatingStarsHtml = (rating: any) => {
  const fullStars = Math.min(5, Math.floor(rating));
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push('<i class="filled">&#9733;</i>');
  }

  if (hasHalfStar) {
    stars.push('<i class="half">&#9733;</i>');
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push('<i class="empty">&#9734;</i>');
  }

  return stars.join("");
};

export function base64ToFile(base64: string, filename: string) {
  const arr = base64.split(",");
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "";
  const bstr = atob(arr[1]); // decode base64
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const getUserProfilePhotoUrl = (
  id: TUser["id"],
  photoName: TUser["photoName"],
) => {
  return photoName
    ? `${process.env.REACT_APP_API_URL}/Account/ProfilePhoto/${id}/${photoName}`
    : "";
};

const formatPlanPrice = (plan: TPricingPlanDto) => {
  return plan.billingCycle === "monthly" ? plan.price : plan.price / 12;
};

export const formatPricingPlansDto = (
  dto: TPricingPlanDto[],
): TPricingPlan[] => {
  return dto.map((plan) => ({
    id: plan.id,
    planId: plan.planId,
    name: plan.planId.split("_")[0],
    price: formatPlanPrice(plan),
    period: plan.billingCycle,
    features: {
      productAnalyzer: {
        lookups: plan.lookupLimit,
        webApp: plan.isWebAvailable,
        chromeExtension: plan.isExtensionAvailable,
      },
      bulkAnalyzer: null,
    },
  }));
};

export const debounce = <T extends unknown[]>(
  callback: (...args: T) => void,
  delay: number,
) => {
  let timeoutTimer: ReturnType<typeof setTimeout>;

  return (...args: T) => {
    clearTimeout(timeoutTimer);

    timeoutTimer = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
